import { render, staticRenderFns } from "./SemSideBar.vue?vue&type=template&id=47056cfa&"
import script from "./SemSideBar.vue?vue&type=script&lang=js&"
export * from "./SemSideBar.vue?vue&type=script&lang=js&"
import style0 from "./SemSideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports